import myAxios from "@/services/api";
import { API_GW_URL } from "@/config/api";

const MESSAGE = {
  DEFAULT: "Tente novamente. Se persistir contacte o suporte!",
  NOTFOUND: "Ordem Inexistente.",
  APIFAIL: "Falha de conexão. Se persistir contacte o suporte!",
  APISUCCESS: "ok",
  SUBMISSIONFAIL: "Falha de Submissão",
};

const API = {
  TASKNOTIFICATION: "/data/getOrderDetailTasksNotification",
  LIST: "/data/getOrderList",
  DETAIL: "/data/getOrderDetail",
  COUNT: "/data/getOrderCount",
  PS: "/data/getPSAndHierarchy",
  MOTIVES: "/data/getConclusionsMotives",
  CODES: "/data/getPerformanceCodes",
  CONCLUSION: "/data/setTechConclusion",
  VALIDATE: "/data/ValidateSubmission",
  TECHNOTES: "/data/setTechNotesToBO",
  TECHDATE: "/data/setTechManualScheduleToBO",
};

async function callAPI(context, apiURLName, data) {
  let header = {
    app_token: context.getters.getUserSession.app_token,
    username: context.getters.getUserDetailList.usr_username,
    tech_ID: context.getters.getUserDetailList.usr_id,
    company_ID: context.getters.getUserDetailList.usr_company_id
  };
  
  try {
    let url = API_GW_URL + apiURLName;
    const response = await myAxios.post(url, { ...header, ...data }, { timeout: 30000 });
    if (response.data?.state !== MESSAGE.APISUCCESS) {
      throw new Error(MESSAGE.APIFAIL);
    }
    if (
      response.data?.data?.data?.length === 0 ||
      response.data?.data?.length === 0
    ) {
      throw new Error(MESSAGE.NOTFOUND);
    }

    return response.data;
  } catch (err) {
    if (err === undefined) err.message = MESSAGE.DEFAULT;
    throw new Error(err.message);
  }
}

export default {
  async getOrderList(context) {
    try {
      const orders = await callAPI(context, API.LIST, {});
      return orders.data.data;
    } catch (err) {
      throw new Error(err.message);
    }
  },

  async getOrderDetail(context, orderID) {
    try {
      const order = await callAPI(context, API.DETAIL, {
        order_ID: orderID,
      });
      return order.data.data[0];
    } catch (err) {
      throw new Error(err.message);
    }
  },

  async getDetailsForSurvey(context, orderID) {
    try {
      const order = await callAPI(context, API.TASKNOTIFICATION, {
        order_ID: orderID,
      });
      return order.data.data[0];
    } catch (err) {
      throw new Error(err.message);
    }
  },

  async getOrderCount(context) {
    try {
      const orderCount = await callAPI(context, API.COUNT, {});
      return orderCount.data.data[0];
    } catch (err) {
      throw new Error(err.message);
    }
  },

  async getPSAndHierarchy(context, orderID) {
    try {
      const orderPS = await callAPI(context, API.PS, {
        order_ID: orderID,
      });
      return orderPS.data.data;
    } catch (err) {
      throw new Error(err.message);
    }
  },

  async doValidateSubmission(context, payload) {
    try {
      const orderValidation = await callAPI(context, API.VALIDATE, {
        requisicao: payload.requisicao,
        scope: payload.scope,
      });
      return orderValidation.data.data;
    } catch (err) {
      throw new Error(err.message);
    }
  },

  async setTechNotes(context, payload) {
    try {
      const orderNotes = await callAPI(context, API.TECHNOTES, {
        order_ID: payload.orderID,
        inserted_text: payload.insertedText,
      });
      if (orderNotes.data?.state !== API.APISUCCESS)
        throw new Error(MESSAGE.SUBMISSIONFAIL);
      else return true;
    } catch (err) {
      throw new Error(err.message);
    }
  },

  async getConclusionsMotives(context, payload) {
    try {
      const orderMotives = await callAPI(context, API.MOTIVES, {
        order_ID: payload.orderID,
        serviceID: payload.serviceID,
      });
      return orderMotives.data.data;
    } catch (err) {
      throw new Error(err.message);
    }
  },

  async getPerformanceCodes(context, payload) {
    try {
      const orderCodes = await callAPI(context, API.CODES, {
        order_ID: payload.orderID,
        serviceID: payload.serviceID,
        conclusionID: payload.conclusionID,
      });
      return orderCodes.data.data;
    } catch (err) {
      throw new Error(err.message);
    }
  },

  async setTechConclusion(context, payload) {
    try {
      const order = await callAPI(context, API.CONCLUSION, {
        order_ID: payload.orderID,
        inserted_text: payload.conclusionText,
        resolutionmotive_id: payload.resolutionMotiveID,
        performancecode_id: payload.performanceCodeID,
      });
      if (order.data?.data.state !== API.APISUCCESS)
        throw new Error(MESSAGE.SUBMISSIONFAIL);
      else return true;
    } catch (err) {
      throw new Error(err.message);
    }
  },

  async setTechDate(context, payload) {
    try {
      const order = await callAPI(context, API.TECHDATE, {
        order_ID: payload.orderID,
        inserted_date: payload.insertedDate,
      });
      if (order.data?.state !== API.APISUCCESS)
        throw new Error(MESSAGE.SUBMISSIONFAIL);
      else return true;
    } catch (err) {
      throw new Error(err.message);
    }
  },
};